import { createContext, useContext, useEffect } from "react";
import useDataPersistent from "../hooks/usedataPersistant";

const WasserAProgressContext = createContext({});

export const WasserAProgressContextProvider = ({ children }) => {
    const markersIds = [
        "wasserA-tom-message-icon",
        "wasserA-tom-message-1",
        "wasserA-tom-message-2",
        "wasserA-lola-message-icon", "wasserA-lola-message-1", "wasserA-lola-message-2",
        "wasserA-lola-message-3", "wasserA-lola-message-4",
        "learn-wasserA-html-marker-tree",
        "learn-wasserA-html-marker-water-boards",
    ];

    const [clickedMarkers, setClickedMarkers] = useDataPersistent(
        "clickedMarkersWasserA",
        []
    );

    const [progress, setProgress] = useDataPersistent("progressWasserA", 0);

    // Automatically calculate progress when clickedMarkers changes
    useEffect(() => {
        const validMarkers = clickedMarkers.filter(marker =>
            markersIds.includes(marker)
        );
        const uniqueMarkers = [...new Set(validMarkers)]; // Remove duplicates
        const currentProgress = uniqueMarkers.length / markersIds.length;
        setProgress(currentProgress);
    }, [clickedMarkers, markersIds.length, setProgress]);

    const countPercentage = (id) => {
        if (!markersIds.includes(id)) {
            return progress; // Return current progress if invalid ID
        }

        // Update clicked markers (will trigger progress calculation via useEffect)
        setClickedMarkers(prev => {
            const newMarkers = [...prev, id];
            return [...new Set(newMarkers)]; // Ensure no duplicates
        });

        return progress; // Progress will be updated by the useEffect
    };

    return (
        <WasserAProgressContext.Provider value={{
            countPercentage,
            clickedMarkers,
            progress
        }}>
            {children}
        </WasserAProgressContext.Provider>
    );
};

export const useWasserAProgress = () => {
    return useContext(WasserAProgressContext);
};